export class ProductPersonalisation extends window.BAO.CustomElement() {
  constructor () {
    super()

    // Elements
    this.input = this.querySelector('[data-product-personalisation-el="input"]')
    this.characterLimitCount = this.querySelector(
      '[data-product-personalisation-el="character-limit-count"]',
    )
    this.characterLimitWrapper = this.querySelector(
      '[data-product-personalisation-el="character-limit-wrapper"]',
    )
    this.lineItemPropertyInput = document.querySelector(
      '[data-personalisation-property]',
    )

    // Data
    this.characterLimitInt = this.input.getAttribute('data-maxlength')

    this.fixInputPadding()
    this.run()
  }

  setupListeners () {
    super.setupListeners()
    this.listeners.add(this.input, 'input', this.run.bind(this))
  }

  run () {
    // Check input value
    let inputValue = this.input.value
    inputValue = this.sanitizeCharacters(inputValue)
    inputValue = this.checkCharacterLimit(inputValue)

    // Update value
    this.input.value = inputValue

    // Update count
    this.characterLimitCount.innerText =
      this.characterLimitInt - inputValue.length

    // Update line item property
    this.lineItemPropertyInput.value = inputValue
  }

  sanitizeCharacters (value) {
    return value.replace(/[^a-zA-Z0-9 ]/g, '')
  }

  checkCharacterLimit (value) {
    return value > this.characterLimitInt
      ? value.substring(0, this.characterLimitInt)
      : value
  }

  fixInputPadding () {
    this.input.style.paddingRight = `${this.characterLimitWrapper.offsetWidth}px`
  }
}

customElements.define('product-personalisation', ProductPersonalisation)
